import axios from 'axios';

/**
 * دالة طباعة سند القبض
 */
export const printReceipt = async (receiptId) => {
  try {
    // جلب بيانات السند
    const receiptResponse = await axios.get(`/api/finance/receipts/${receiptId}`, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem('token')}`
      }
    });

    const receipt = receiptResponse.data.data || receiptResponse.data.receipt;

    // جلب بيانات الفرع
    let branch = null;
    if (receipt.branchId) {
      try {
        // التأكد من أن branchId هو string وليس object
        const branchId = typeof receipt.branchId === 'object' ? receipt.branchId._id || receipt.branchId.id : receipt.branchId;
        const branchResponse = await axios.get(`/api/branches/${branchId}`, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem('token')}`
          }
        });
        branch = branchResponse.data;
      } catch (error) {
        console.error('خطأ في جلب بيانات الفرع:', error);
      }
    }

    // تنسيق التاريخ
    const formatDate = (dateString) => {
      const date = new Date(dateString);
      return date.toLocaleDateString('ar-SA', {
        year: 'numeric',
        month: 'long',
        day: 'numeric'
      });
    };

    // تنسيق المبلغ
    const formatCurrency = (amount) => {
      return new Intl.NumberFormat('ar-SA', {
        style: 'currency',
        currency: 'SAR'
      }).format(amount);
    };

    // إنشاء HTML للطباعة
    const printHTML = `
<!DOCTYPE html>
<html dir="rtl" lang="ar">
<head>
  <meta charset="UTF-8">
  <title>سند قبض - ${receipt.receiptNumber}</title>
  <style>
    * {
      margin: 0;
      padding: 0;
      box-sizing: border-box;
    }
    
    body {
      font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
      font-size: 12px;
      line-height: 1.4;
      padding: 10px;
      direction: rtl;
    }
    
    .voucher-container {
      max-width: 210mm;
      margin: 0 auto;
      border: 2px solid #000;
      padding: 15px;
    }
    
    .header {
      text-align: center;
      margin-bottom: 15px;
      padding-bottom: 10px;
      border-bottom: 2px solid #333;
    }
    
    .logo {
      margin-bottom: 8px;
    }
    
    .logo img {
      max-height: 70px;
      max-width: 150px;
    }
    
    .establishment-info {
      margin-bottom: 8px;
      white-space: pre-line;
      line-height: 1.4;
      font-size: 11px;
      color: #333;
    }
    
    .branch-info {
      margin-bottom: 8px;
    }
    
    .branch-name {
      font-size: 16px;
      font-weight: bold;
      margin-bottom: 3px;
      color: #000;
    }
    
    .branch-details {
      font-size: 11px;
      color: #666;
      margin-top: 3px;
    }
    
    .voucher-title {
      font-size: 24px;
      font-weight: bold;
      margin: 10px 0 5px 0;
      color: #000;
    }
    
    .voucher-number {
      font-size: 14px;
      color: #666;
      margin-bottom: 5px;
    }
    
    .info-section {
      margin: 10px 0;
    }
    
    .info-grid {
      display: grid;
      grid-template-columns: 1fr 1fr;
      gap: 10px;
      margin-bottom: 10px;
    }
    
    table {
      width: 100%;
      border-collapse: collapse;
      margin-bottom: 8px;
    }
    
    td {
      padding: 6px 8px;
      border: 1px solid #333;
      font-size: 12px;
    }
    
    .label-cell {
      font-weight: bold;
      background-color: #f5f5f5;
      width: 35%;
    }
    
    .amount-cell {
      font-weight: bold;
      font-size: 16px;
      color: #000;
    }
    
    .section-title {
      font-size: 14px;
      font-weight: bold;
      margin: 12px 0 6px 0;
      color: #000;
    }
    
    .description-box {
      border: 1px solid #333;
      padding: 8px;
      min-height: 60px;
      background-color: #fafafa;
      margin-bottom: 10px;
      line-height: 1.4;
      font-size: 12px;
    }
    
    .signatures {
      display: grid;
      grid-template-columns: 1fr 1fr 1fr;
      gap: 20px;
      margin-top: 40px;
    }
    
    .signature-box {
      text-align: center;
    }
    
    .signature-line {
      border-top: 2px solid #000;
      margin-bottom: 5px;
      padding-top: 30px;
    }
    
    .signature-label {
      font-weight: bold;
      font-size: 12px;
    }
    
    @media print {
      body {
        padding: 0;
      }
      
      @page {
        size: A4;
        margin: 15mm;
      }
    }
  </style>
</head>
<body>
  <div class="voucher-container">
    <div class="header">
      ${branch?.logo ? `
        <div class="logo">
          <img src="${branch.logo}" alt="شعار الفرع" />
        </div>
      ` : ''}
      
      ${branch?.establishmentInfo ? `
        <div class="establishment-info">${branch.establishmentInfo}</div>
      ` : ''}
      
      <div class="voucher-title">سند قبض</div>
      <div class="voucher-number">${receipt.receiptNumber}</div>
    </div>
    
    <div class="info-section">
      <div class="info-grid">
        <table>
          <tr>
            <td class="label-cell">التاريخ:</td>
            <td>${formatDate(receipt.date)}</td>
          </tr>
        </table>
        
        <table>
          <tr>
            <td class="label-cell">المبلغ:</td>
            <td class="amount-cell">${formatCurrency(receipt.amount)}</td>
          </tr>
        </table>
      </div>
      
      <div class="section-title">تفاصيل الحساب</div>
      <table>
        <tr>
          <td class="label-cell">استلمنا من:</td>
          <td>
            ${receipt.creditAccount.name}
            ${receipt.creditAccount.accountNumber ? ` (${receipt.creditAccount.accountNumber})` : ''}
          </td>
        </tr>
      </table>
      
      <div class="section-title">البيان</div>
      <div class="description-box">
        ${receipt.description}
      </div>
      
      <table>
        <tr>
          <td class="label-cell">أنشئ بواسطة:</td>
          <td>${receipt.createdBy}</td>
        </tr>
        ${receipt.approvedBy ? `
          <tr>
            <td class="label-cell">اعتمد بواسطة:</td>
            <td>
              ${receipt.approvedBy}
              ${receipt.approvedAt ? ` - ${formatDate(receipt.approvedAt)}` : ''}
            </td>
          </tr>
        ` : ''}
      </table>
    </div>
    
    <div class="signatures">
      <div class="signature-box">
        <div class="signature-line"></div>
        <div class="signature-label">المستلم</div>
      </div>
      <div class="signature-box">
        <div class="signature-line"></div>
        <div class="signature-label">المحاسب</div>
      </div>
      <div class="signature-box">
        <div class="signature-line"></div>
        <div class="signature-label">المدير المالي</div>
      </div>
    </div>
  </div>
  
  <script>
    // طباعة تلقائية عند فتح النافذة
    window.onload = function() {
      setTimeout(function() {
        window.print();
      }, 250);
    };
  </script>
</body>
</html>
    `;

    // فتح نافذة جديدة
    const printWindow = window.open('', '_blank', 'width=900,height=700');
    
    if (printWindow) {
      printWindow.document.write(printHTML);
      printWindow.document.close();
    } else {
      alert('يرجى السماح بفتح النوافذ المنبثقة لطباعة السند');
    }
  } catch (error) {
    console.error('خطأ في طباعة سند القبض:', error);
    alert('حدث خطأ أثناء طباعة السند: ' + (error.response?.data?.message || error.message));
  }
};

/**
 * دالة طباعة سند الصرف
 */
export const printPayment = async (paymentId) => {
  try {
    // جلب بيانات السند
    const paymentResponse = await axios.get(`/api/finance/payments/${paymentId}`, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem('token')}`
      }
    });

    const payment = paymentResponse.data;

    // جلب بيانات الفرع
    let branch = null;
    if (payment.branchId) {
      try {
        // التأكد من أن branchId هو string وليس object
        const branchId = typeof payment.branchId === 'object' ? payment.branchId._id || payment.branchId.id : payment.branchId;
        const branchResponse = await axios.get(`/api/branches/${branchId}`, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem('token')}`
          }
        });
        branch = branchResponse.data;
      } catch (error) {
        console.error('خطأ في جلب بيانات الفرع:', error);
      }
    }

    // تنسيق التاريخ
    const formatDate = (dateString) => {
      const date = new Date(dateString);
      return date.toLocaleDateString('ar-SA', {
        year: 'numeric',
        month: 'long',
        day: 'numeric'
      });
    };

    // تنسيق المبلغ
    const formatCurrency = (amount) => {
      return new Intl.NumberFormat('ar-SA', {
        style: 'currency',
        currency: 'SAR'
      }).format(amount);
    };

    // إنشاء HTML للطباعة
    const printHTML = `
<!DOCTYPE html>
<html dir="rtl" lang="ar">
<head>
  <meta charset="UTF-8">
  <title>سند صرف - ${payment.paymentNumber}</title>
  <style>
    * {
      margin: 0;
      padding: 0;
      box-sizing: border-box;
    }
    
    body {
      font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
      font-size: 12px;
      line-height: 1.4;
      padding: 10px;
      direction: rtl;
    }
    
    .voucher-container {
      max-width: 210mm;
      margin: 0 auto;
      border: 2px solid #000;
      padding: 15px;
    }
    
    .header {
      text-align: center;
      margin-bottom: 15px;
      padding-bottom: 10px;
      border-bottom: 2px solid #333;
    }
    
    .logo {
      margin-bottom: 8px;
    }
    
    .logo img {
      max-height: 70px;
      max-width: 150px;
    }
    
    .establishment-info {
      margin-bottom: 8px;
      white-space: pre-line;
      line-height: 1.4;
      font-size: 11px;
      color: #333;
    }
    
    .branch-info {
      margin-bottom: 8px;
    }
    
    .branch-name {
      font-size: 16px;
      font-weight: bold;
      margin-bottom: 3px;
      color: #000;
    }
    
    .branch-details {
      font-size: 11px;
      color: #666;
      margin-top: 3px;
    }
    
    .voucher-title {
      font-size: 24px;
      font-weight: bold;
      margin: 10px 0 5px 0;
      color: #000;
    }
    
    .voucher-number {
      font-size: 14px;
      color: #666;
      margin-bottom: 5px;
    }
    
    .info-section {
      margin: 10px 0;
    }
    
    .info-grid {
      display: grid;
      grid-template-columns: 1fr 1fr;
      gap: 10px;
      margin-bottom: 10px;
    }
    
    table {
      width: 100%;
      border-collapse: collapse;
      margin-bottom: 8px;
    }
    
    td {
      padding: 6px 8px;
      border: 1px solid #333;
      font-size: 12px;
    }
    
    .label-cell {
      font-weight: bold;
      background-color: #f5f5f5;
      width: 35%;
    }
    
    .amount-cell {
      font-weight: bold;
      font-size: 16px;
      color: #000;
    }
    
    .section-title {
      font-size: 14px;
      font-weight: bold;
      margin: 12px 0 6px 0;
      color: #000;
    }
    
    .description-box {
      border: 1px solid #333;
      padding: 8px;
      min-height: 60px;
      background-color: #fafafa;
      margin-bottom: 10px;
      line-height: 1.4;
      font-size: 12px;
    }
    
    .signatures {
      display: grid;
      grid-template-columns: 1fr 1fr 1fr;
      gap: 20px;
      margin-top: 40px;
    }
    
    .signature-box {
      text-align: center;
    }
    
    .signature-line {
      border-top: 2px solid #000;
      margin-bottom: 5px;
      padding-top: 30px;
    }
    
    .signature-label {
      font-weight: bold;
      font-size: 12px;
    }
    
    @media print {
      body {
        padding: 0;
      }
      
      @page {
        size: A4;
        margin: 15mm;
      }
    }
  </style>
</head>
<body>
  <div class="voucher-container">
    <div class="header">
      ${branch?.logo ? `
        <div class="logo">
          <img src="${branch.logo}" alt="شعار الفرع" />
        </div>
      ` : ''}
      
      ${branch?.establishmentInfo ? `
        <div class="establishment-info">${branch.establishmentInfo}</div>
      ` : ''}
      
      <div class="voucher-title">سند صرف</div>
      <div class="voucher-number">${payment.paymentNumber}</div>
    </div>
    
    <div class="info-section">
      <div class="info-grid">
        <table>
          <tr>
            <td class="label-cell">التاريخ:</td>
            <td>${formatDate(payment.date)}</td>
          </tr>
        </table>
        
        <table>
          <tr>
            <td class="label-cell">المبلغ:</td>
            <td class="amount-cell">${formatCurrency(payment.amount)}</td>
          </tr>
        </table>
      </div>
      
      <div class="section-title">تفاصيل الحسابات</div>
      <table>
        <tr>
          <td class="label-cell">من حساب (المدين):</td>
          <td>
            ${payment.debitAccount.name}
            ${payment.debitAccount.accountNumber ? ` (${payment.debitAccount.accountNumber})` : ''}
          </td>
        </tr>
        <tr>
          <td class="label-cell">إلى حساب (الدائن):</td>
          <td>
            ${payment.creditAccount.name}
            ${payment.creditAccount.accountNumber ? ` (${payment.creditAccount.accountNumber})` : ''}
          </td>
        </tr>
      </table>
      
      <div class="section-title">البيان</div>
      <div class="description-box">
        ${payment.description}
      </div>
      
      <table>
        <tr>
          <td class="label-cell">أنشئ بواسطة:</td>
          <td>${payment.createdBy}</td>
        </tr>
        ${payment.approvedBy ? `
          <tr>
            <td class="label-cell">اعتمد بواسطة:</td>
            <td>
              ${payment.approvedBy}
              ${payment.approvedAt ? ` - ${formatDate(payment.approvedAt)}` : ''}
            </td>
          </tr>
        ` : ''}
      </table>
    </div>
    
    <div class="signatures">
      <div class="signature-box">
        <div class="signature-line"></div>
        <div class="signature-label">المستلم</div>
      </div>
      <div class="signature-box">
        <div class="signature-line"></div>
        <div class="signature-label">المحاسب</div>
      </div>
      <div class="signature-box">
        <div class="signature-line"></div>
        <div class="signature-label">المدير المالي</div>
      </div>
    </div>
  </div>
  
  <script>
    // طباعة تلقائية عند فتح النافذة
    window.onload = function() {
      setTimeout(function() {
        window.print();
      }, 250);
    };
  </script>
</body>
</html>
    `;

    // فتح نافذة جديدة
    const printWindow = window.open('', '_blank', 'width=900,height=700');
    
    if (printWindow) {
      printWindow.document.write(printHTML);
      printWindow.document.close();
    } else {
      alert('يرجى السماح بفتح النوافذ المنبثقة لطباعة السند');
    }
  } catch (error) {
    console.error('خطأ في طباعة سند الصرف:', error);
    alert('حدث خطأ أثناء طباعة السند: ' + (error.response?.data?.message || error.message));
  }
};

/**
 * دالة طباعة السند المتخصص
 */
export const printSpecializedVoucher = async (voucherId) => {
  try {
    // جلب بيانات السند المتخصص
    const voucherResponse = await axios.get(`/api/finance/specialized-vouchers/${voucherId}`, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem('token')}`
      }
    });

    const voucher = voucherResponse.data;

    // جلب بيانات الفرع
    let branch = null;
    if (voucher.branch) {
      try {
        const branchId = typeof voucher.branch === 'object' ? voucher.branch._id || voucher.branch.id : voucher.branch;
        const branchResponse = await axios.get(`/api/branches/${branchId}`, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem('token')}`
          }
        });
        branch = branchResponse.data;
      } catch (error) {
        console.error('خطأ في جلب بيانات الفرع:', error);
      }
    }

    // تنسيق التاريخ
    const formatDate = (dateString) => {
      const date = new Date(dateString);
      return date.toLocaleDateString('ar-SA', {
        year: 'numeric',
        month: 'long',
        day: 'numeric'
      });
    };

    // تنسيق المبلغ
    const formatCurrency = (amount) => {
      return new Intl.NumberFormat('ar-SA', {
        style: 'currency',
        currency: 'SAR'
      }).format(amount);
    };

    // تحديد نوع السند
    const getVoucherTypeText = (type) => {
      switch(type) {
        case 'receipt': return 'سند قبض متخصص';
        case 'payment': return 'سند صرف متخصص';
        case 'journal': return 'سند موازنة متخصص';
        default: return 'سند متخصص';
      }
    };

    // إنشاء HTML للطباعة
    const printHTML = `
<!DOCTYPE html>
<html dir="rtl" lang="ar">
<head>
  <meta charset="UTF-8">
  <title>${getVoucherTypeText(voucher.voucherType)} - ${voucher.voucherNumber}</title>
  <style>
    * {
      margin: 0;
      padding: 0;
      box-sizing: border-box;
    }
    
    body {
      font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
      font-size: 12px;
      line-height: 1.4;
      padding: 10px;
      direction: rtl;
    }
    
    .voucher-container {
      max-width: 210mm;
      margin: 0 auto;
      border: 2px solid #000;
      padding: 15px;
    }
    
    .header {
      text-align: center;
      margin-bottom: 15px;
      padding-bottom: 10px;
      border-bottom: 2px solid #333;
    }
    
    .logo {
      margin-bottom: 8px;
    }
    
    .logo img {
      max-height: 70px;
      max-width: 150px;
    }
    
    .establishment-info {
      margin-bottom: 8px;
      white-space: pre-line;
      line-height: 1.4;
      font-size: 11px;
      color: #333;
    }
    
    .branch-info {
      margin-bottom: 8px;
    }
    
    .branch-name {
      font-size: 16px;
      font-weight: bold;
      margin-bottom: 3px;
      color: #000;
    }
    
    .branch-details {
      font-size: 11px;
      color: #666;
      margin-top: 3px;
    }
    
    .voucher-title {
      font-size: 24px;
      font-weight: bold;
      margin: 10px 0 5px 0;
      color: #000;
    }
    
    .voucher-number {
      font-size: 14px;
      color: #666;
      margin-bottom: 5px;
    }
    
    .template-name {
      font-size: 12px;
      color: #30c3b0;
      font-weight: 600;
      margin-bottom: 5px;
    }
    
    .info-section {
      margin: 10px 0;
    }
    
    .info-grid {
      display: grid;
      grid-template-columns: 1fr 1fr;
      gap: 10px;
      margin-bottom: 10px;
    }
    
    table {
      width: 100%;
      border-collapse: collapse;
      margin-bottom: 8px;
    }
    
    td {
      padding: 6px 8px;
      border: 1px solid #333;
      font-size: 12px;
    }
    
    .label-cell {
      font-weight: bold;
      background-color: #f5f5f5;
      width: 35%;
    }
    
    .amount-cell {
      font-weight: bold;
      font-size: 16px;
      color: #000;
    }
    
    .section-title {
      font-size: 14px;
      font-weight: bold;
      margin: 12px 0 6px 0;
      color: #000;
    }
    
    .description-box {
      border: 1px solid #333;
      padding: 8px;
      min-height: 60px;
      background-color: #fafafa;
      margin-bottom: 10px;
      line-height: 1.4;
      font-size: 12px;
    }
    
    .fees-section {
      background-color: #f9f9f9;
      border: 1px solid #ddd;
      padding: 10px;
      margin: 10px 0;
      border-radius: 4px;
    }
    
    .fee-item {
      display: flex;
      justify-content: space-between;
      padding: 4px 0;
      border-bottom: 1px dashed #ddd;
    }
    
    .fee-item:last-child {
      border-bottom: none;
      font-weight: bold;
      margin-top: 5px;
      padding-top: 8px;
      border-top: 2px solid #333;
    }
    
    .signatures {
      display: grid;
      grid-template-columns: 1fr 1fr 1fr;
      gap: 20px;
      margin-top: 40px;
    }
    
    .signature-box {
      text-align: center;
    }
    
    .signature-line {
      border-top: 2px solid #000;
      margin-bottom: 5px;
      padding-top: 30px;
    }
    
    .signature-label {
      font-weight: bold;
      font-size: 12px;
    }
    
    @media print {
      body {
        padding: 0;
      }
      
      @page {
        size: A4;
        margin: 15mm;
      }
    }
  </style>
</head>
<body>
  <div class="voucher-container">
    <div class="header">
      ${branch?.logo ? `
        <div class="logo">
          <img src="${branch.logo}" alt="شعار الفرع" />
        </div>
      ` : ''}
      
      ${branch?.establishmentInfo ? `
        <div class="establishment-info">${branch.establishmentInfo}</div>
      ` : ''}
      
      ${branch ? `
        <div class="branch-info">
          <div class="branch-name">${branch.name}</div>
          ${branch.address ? `<div class="branch-details">${branch.address}</div>` : ''}
          <div class="branch-details">
            ${branch.phone ? `هاتف: ${branch.phone}` : ''}
            ${branch.phone && branch.email ? ' | ' : ''}
            ${branch.email ? `بريد: ${branch.email}` : ''}
          </div>
        </div>
      ` : ''}
      
      <div class="voucher-title">${getVoucherTypeText(voucher.voucherType)}</div>
      <div class="voucher-number">${voucher.voucherNumber}</div>
      ${voucher.templateName ? `<div class="template-name">القالب: ${voucher.templateName}</div>` : ''}
    </div>
    
    <div class="info-section">
      <div class="info-grid">
        <table>
          <tr>
            <td class="label-cell">التاريخ:</td>
            <td>${formatDate(voucher.voucherDate)}</td>
          </tr>
          <tr>
            <td class="label-cell">الحالة:</td>
            <td>${voucher.isApproved ? 'معتمد' : 'قيد الانتظار'}</td>
          </tr>
          ${voucher.operationNumber ? `
            <tr>
              <td class="label-cell">رقم العملية:</td>
              <td>${voucher.operationNumber}</td>
            </tr>
          ` : ''}
        </table>
        
        <table>
          <tr>
            <td class="label-cell">المبلغ:</td>
            <td class="amount-cell">${formatCurrency(voucher.amount)}</td>
          </tr>
          <tr>
            <td class="label-cell">الفرع:</td>
            <td>${branch?.name || 'غير محدد'}</td>
          </tr>
        </table>
      </div>
      
      <div class="section-title">تفاصيل الحسابات</div>
      <table>
        <tr>
          <td class="label-cell">${voucher.voucherType === 'receipt' ? 'استلمنا من' : 'من حساب'} (المدين):</td>
          <td>${voucher.debitAccountName || 'غير محدد'}</td>
        </tr>
        <tr>
          <td class="label-cell">${voucher.voucherType === 'receipt' ? 'لحساب' : 'إلى حساب'} (الدائن):</td>
          <td>${voucher.creditAccountName || 'غير محدد'}</td>
        </tr>
      </table>
      
      ${voucher.notes ? `
        <div class="section-title">الملاحظات</div>
        <div class="description-box">
          ${voucher.notes}
        </div>
      ` : ''}
      
      ${voucher.calculatedFees ? `
        <div class="section-title">الرسوم المطبقة</div>
        <div class="fees-section">
          ${voucher.appliedFeeGroupName ? `<div style="margin-bottom: 8px; font-weight: 600;">مجموعة الرسوم: ${voucher.appliedFeeGroupName}</div>` : ''}
          ${Object.entries(voucher.calculatedFees).map(([key, value]) => {
            if (key === 'total') {
              return `<div class="fee-item"><span>إجمالي الرسوم:</span><span>${formatCurrency(value)}</span></div>`;
            }
            return `<div class="fee-item"><span>${key}:</span><span>${formatCurrency(value)}</span></div>`;
          }).join('')}
        </div>
      ` : ''}
      
      <table>
        <tr>
          <td class="label-cell">أنشئ بواسطة:</td>
          <td>${voucher.createdBy || 'غير محدد'}</td>
        </tr>
        ${voucher.approvedBy ? `
          <tr>
            <td class="label-cell">اعتمد بواسطة:</td>
            <td>
              ${voucher.approvedBy}
              ${voucher.approvedAt ? ` - ${formatDate(voucher.approvedAt)}` : ''}
            </td>
          </tr>
        ` : ''}
      </table>
    </div>
    
    <div class="signatures">
      <div class="signature-box">
        <div class="signature-line"></div>
        <div class="signature-label">${voucher.voucherType === 'receipt' ? 'المستلم' : 'المستلم'}</div>
      </div>
      <div class="signature-box">
        <div class="signature-line"></div>
        <div class="signature-label">المحاسب</div>
      </div>
      <div class="signature-box">
        <div class="signature-line"></div>
        <div class="signature-label">المدير المالي</div>
      </div>
    </div>
  </div>
  
  <script>
    // طباعة تلقائية عند فتح النافذة
    window.onload = function() {
      setTimeout(function() {
        window.print();
      }, 250);
    };
  </script>
</body>
</html>
    `;

    // فتح نافذة جديدة
    const printWindow = window.open('', '_blank', 'width=900,height=700');
    
    if (printWindow) {
      printWindow.document.write(printHTML);
      printWindow.document.close();
    } else {
      alert('يرجى السماح بفتح النوافذ المنبثقة لطباعة السند');
    }
  } catch (error) {
    console.error('خطأ في طباعة السند المتخصص:', error);
    alert('حدث خطأ أثناء طباعة السند: ' + (error.response?.data?.message || error.message));
  }
};